import SsoProviders from "../constants/ssoProviders"

export default function getSSOProviders(queryParamString) {
    let params = new URLSearchParams(queryParamString);
    const providers = [];
    if (params.has("ssoids")) {
        const ssoIds = params.getAll("ssoids");
        for (const [key, value] of Object.entries(SsoProviders)) {
            if (ssoIds.includes(key)) {
                providers.push(value)
            }
        }
    }
    return providers
}
